import { render, staticRenderFns } from "./AsyncSaveButton.vue?vue&type=template&id=06f850a6&"
import script from "./AsyncSaveButton.vue?vue&type=script&lang=ts&"
export * from "./AsyncSaveButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports